// extracted by mini-css-extract-plugin
export var readonly = "_b5-1";
export var star = "_b5-0";